<script>
  import { onMount } from "svelte";
  import Tool from "./Tool.svelte";
  import { Theme, FontsUrban } from "@urbaninstitute/dataviz-components";
  import appCss from "../../app.css?inline";

  let thisHost = $host();

  onMount(() => {
    const shadow = thisHost?.shadowRoot;
    if (!shadow) return;

    // Prevent duplicate injection if component re-initializes
    if (shadow.querySelector("style[data-tailwind-shadow]")) return;

    const styleEl = document.createElement("style");
    styleEl.setAttribute("data-tailwind-shadow", "true");
    styleEl.textContent = appCss;
    shadow.prepend(styleEl);
  });
</script>

<svelte:options customElement={{ tag: "data-tool" }} />

<FontsUrban />
<Theme>
  <Tool />
</Theme>
